import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	deleteGroupTitle: {
		id: 'portal-settings-request-groups.common.flags.delete-group-title',
		defaultMessage: "We couldn't delete that group",
		description: 'Title of the error flag when deleting of group fails',
	},
	reorderGroupTitle: {
		id: 'portal-settings-request-groups.common.flags.reorder-group-title',
		defaultMessage: "We couldn't move that group",
		description: 'Title of the error flag when reordering of group fails',
	},
	updateGroupTitle: {
		id: 'portal-settings-request-groups.common.flags.update-group-title',
		defaultMessage: "We couldn't update that group",
		description: 'Title of the error flag when updating group name fails',
	},
	updateGroupNameUsed: {
		id: 'portal-settings-request-groups.common.flags.update-group-name-used',
		defaultMessage: 'Group name already in use, try another.',
		description: 'Message in flag when user tries to name a group that is the same as another',
	},
	addFormTitle: {
		id: 'portal-settings-request-groups.common.flags.add-form-title',
		defaultMessage: "We couldn't add that request form",
		description: 'Title of the error flag when adding request form to a group fails',
	},
	removeFormTitle: {
		id: 'portal-settings-request-groups.common.flags.remove-form-title',
		defaultMessage: "We couldn't remove that request form",
		description: 'Title of the error flag when removing of request form from a group fails',
	},
	reorderFormTitle: {
		id: 'portal-settings-request-groups.common.flags.reorder-form-title',
		defaultMessage: "We couldn't move that request form",
		description: 'Title of the error flag when reordering of request form fails',
	},
	groupNotFound: {
		id: 'portal-settings-request-groups.common.flags.group-not-found',
		defaultMessage: 'This group no longer exists. Refresh to get up to date.',
		description: 'Message in flag when user tries to perform an action on already deleted group',
	},
	groupNameTooLongError: {
		id: 'portal-settings-request-groups.common.flags.group-name-too-long-error',
		defaultMessage: "Group name can't be longer than 128 characters.",
		description: 'Message shown when creating a group with a name that is too long',
	},
	missingGroupNameError: {
		id: 'portal-settings-request-groups.common.flags.missing-group-name-error',
		defaultMessage: "Group name can't be empty.",
		description: 'Message shown when creating a group with no name',
	},
	formNotFound: {
		id: 'portal-settings-request-groups.common.flags.form-not-found',
		defaultMessage: 'This request form no longer exists. Refresh to get up to date.',
		description:
			'Message in flag when user tries to perform an action on already deleted request form',
	},
	formInvalid: {
		id: 'portal-settings-request-groups.common.flags.form-invalid',
		defaultMessage: 'This request form is invalid. Refresh to get up to date.',
		description: 'Message in flag when user tries to perform an action on a invalid request form',
	},
	dataReverted: {
		id: 'portal-settings-request-groups.common.flags.data-reverted',
		defaultMessage: "We've put things back the way they were. Refresh or try again.",
		description: 'Message in flag when data on the page has been reverted back',
	},
	dataStale: {
		id: 'portal-settings-request-groups.common.flags.data-stale',
		defaultMessage: 'This page may not be up to date. Refresh and try again.',
		description: 'Message in flag when data on page is not up to date',
	},
	genericErrorTitle: {
		id: 'portal-settings-request-groups.common.flags.generic-error-title',
		defaultMessage: "Something's gone wrong",
		description: 'Generic error title when error happens',
	},
	genericErrorDescription: {
		id: 'portal-settings-request-groups.common.flags.generic-error-description',
		defaultMessage: 'Refresh and try again.',
		description: 'Generic error message when error happens',
	},
	refreshAction: {
		id: 'portal-settings-request-groups.common.flags.refresh-action',
		defaultMessage: 'Refresh',
		description: 'Label used in refresh button that will refresh the page',
	},
});
